<div class="view-column-container">
  <!-- Description -->
  <app-view-column class="view-column-container__inner" @slideInOut *ngIf="isVisible(viewLayout.Column)">
    <ng-container view-column-header>
      <app-view-internal-header *appFlagApplication="application.Viewer; mode:'exclude'"></app-view-internal-header>
    </ng-container>

    <ng-container view-column-body>
      <app-view-content-mode layout="column"></app-view-content-mode>
    </ng-container>
  </app-view-column>

  <!-- Search -->
  <app-view-column class="view-column-container__inner" [unpadded]="true" @slideInOut *ngIf="isVisible(viewLayout.Search)">
    <app-view-search></app-view-search>
  </app-view-column>

  <!-- Node Info -->
  <app-view-column class="view-column-container__inner" @slideInOut *ngIf="isVisible(viewLayout.NodeInfo)">
    <app-view-node-description layout="column"></app-view-node-description>
  </app-view-column>
</div>